import { ReactElement, useEffect, useState } from 'react';
import { useRouteLoaderData } from 'react-router-dom';

import { format } from 'date-fns';

import { useHirePlanForm } from '../../../../../../contexts/HirePlanFormProvider';
import { useHirePlanForm as useHirePlanFormGdf } from '../../../../../../contexts/HirePlanFormProviderGdf';
import { InfoIcon } from '../../../../../icons/InfoIcon';
import { Input } from '../../../../../Input';
import { Select } from '../../../../../Select';
import { PaymentBilletForm } from './BilletForm';

export function PaymentDebitForm(): ReactElement {
  const IndividualData: any = useRouteLoaderData('token');
  const ServerData: any = useRouteLoaderData('token-servidor');
  const { register, errors, watch } = useHirePlanForm();
  const {
    register: registerGdf,
    errors: errorsGdf,
    watch: watchGdf,
  } = useHirePlanFormGdf();
  const data = IndividualData || ServerData;
  const [firstPaymentBillet, setFirstPaymentBillet] = useState(false);

  interface Operation {
    Nome: string;
    Id: string;
  }

  const operation: Operation[] = [
    { Nome: 'Conta corrente -- 001', Id: '001' },
    { Nome: 'Conta poupança -- 013', Id: '013' },
  ];

  const renameBanco = () => {
    data.bancos.map(banco => {
      banco.Nome = banco.nm_banco;
      banco.Id = banco.id_banco;
    });
  };
  renameBanco();

  useEffect(() => {
    if (IndividualData) {
      setFirstPaymentBillet(watch('payment.firstPaymentBillet'));
    } else {
      setFirstPaymentBillet(watchGdf('payment.firstPaymentBillet'));
    }
  }, [
    IndividualData
      ? watch('payment.firstPaymentBillet')
      : watchGdf('payment.firstPaymentBillet'),
  ]);

  return (
    <div className="max-[1000px]:flex-col max-[1000px]:items-center min-[748px]:mt-6 min-[748px]:p-6 min-[748px]:pt-4 w-full flex flex-col justify-center">
      <span className="text-primary-main text-xl font-medium mb-8">
        Dados da conta
      </span>
      <div className="grid min-[748px]:grid-cols-1">
        <div className="grid grid-cols-1 gap-6">
          <div className="grid grid-cols-3 gap-8">
            <Select
              label="Banco"
              options={[]}
              optionsFull={data.bancos}
              placeholder="Banco"
              errorMessage={
                IndividualData
                  ? errors.payment?.bank?.message
                  : errorsGdf.payment?.bank?.message
              }
              {...(IndividualData
                ? register('payment.bank')
                : registerGdf('payment.bank'))}
            />
            <Input
              label="Agência"
              className="w-full"
              placeholder="00"
              errorMessage={
                IndividualData
                  ? errors.payment?.agency?.message
                  : errorsGdf.payment?.agency?.message
              }
              {...(IndividualData
                ? register('payment.agency')
                : registerGdf('payment.agency'))}
            />
            <Input
              label="Conta corrente"
              className="w-full"
              placeholder="000 000-0"
              errorMessage={
                IndividualData
                  ? errors.payment?.debitAcount?.message
                  : errorsGdf.payment?.debitAcount?.message
              }
              {...(IndividualData
                ? register('payment.debitAcount')
                : registerGdf('payment.debitAcount'))}
            />
          </div>
          <div className="grid grid-cols-3 gap-8">
            <Select
              label="Operação"
              options={[]}
              optionsFull={operation}
              placeholder="Operação"
              errorMessage={
                IndividualData
                  ? errors.payment?.operation?.message
                  : errorsGdf.payment?.operation?.message
              }
              {...(IndividualData
                ? register('payment.operation')
                : registerGdf('payment.operation'))}
            />
            {!firstPaymentBillet && (
              <Select
                label="Dia vencimento"
                options={data.vencimentoDebito?.map(boleto =>
                  format(new Date(boleto.select), 'dd/MM/yyyy'),
                )}
                placeholder="Dia vencimento"
                errorMessage={
                  IndividualData
                    ? errors.payment?.debitDate?.message
                    : errorsGdf.payment?.debitDate?.message
                }
                {...(IndividualData
                  ? register('payment.debitDate')
                  : registerGdf('payment.debitDate'))}
              />
            )}
          </div>
        </div>
      </div>
      <div className="flex items-start border bg-primary-container2 rounded-md w-full py-6 px-4 mt-6">
        {/* <InfoIcon className="flex-none items-center min-w-[30px]" /> */}
        <div className="grid grid-cols-1 gap-8">
          <Input
            className="w-[20px] h-[20px]"
            label=""
            type="checkbox"
            errorMessage={
              IndividualData
                ? errors.payment?.firstPaymentBillet?.message
                : errorsGdf.payment?.firstPaymentBillet?.message
            }
            {...(IndividualData
              ? register('payment.firstPaymentBillet')
              : registerGdf('payment.firstPaymentBillet'))}
          />
        </div>
        {/* <input
          type="checkbox"
          className="w-full placeholder:text-medium-emphasis px-4 py-3 rounded-lg text-high-emphasis border focus:ring-1 focus:outline-none"
        ></input> */}
        <span className="flex-1 text-neutral-dark text-sm ml-4">
          <span className="font-bold block">
            Quero pagar a primeira no boleto.
          </span>
          Selecionando essa opção, seu plano ficará disponível assim que a
          OdontoGroup reconhecer o pagamento do seu boleto. As outras
          mensalidades serão cobradas normalmente na conta cadastrada. O boleto
          será enviado para seu email após o envio desse formulário.
        </span>
      </div>
      {firstPaymentBillet && <PaymentBilletForm />}
    </div>
  );
}
